(function ($) {
    $(document).on('change', '.js-choose-saved-address', function (e) {
        let group = "input:checkbox[name='"+$(this).prop("name")+"']";
        $(group).prop("checked",false);
        $(this).prop("checked",true);

        let address = $(this).data()
        $('#shipping_first_name').attr('value', address.address_first_name)
        $('#shipping_last_name').attr('value', address.address_last_name)
        $('#shipping_address_1').attr('value', address.address_street_address_1)
        $('#shipping_address_2').attr('value', address.address_street_address_2)
        $('#shipping_city').attr('value', address.address_town_city)
        $('#shipping_postcode').attr('value', address.address_postcode)
    });
})(jQuery);
